// removed by extract-text-webpack-plugin
module.exports = {"image":"K8yf_","imageTopLeft":"_3_RuR K8yf_","topLeft":"_1_qg1","imageTopRight":"_1xGwz K8yf_","topRight":"_3GJLb","imageBottomLeft":"_3IPgA K8yf_","bottomLeft":"rKwv2","imageBottomRight":"S0i3t K8yf_","bottomRight":"_1xs6x","enter":"plCyj","enterActive":"_3aAwp","leave":"Eo1iq","leaveActive":"_2-2rV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/present/KenBurns.css
// module id = 838
// module chunks = 0